import React from "react";
import HomeIndex from "../components/Home/Index";

const Home = () => {
    return (
        <div>
            <HomeIndex />
        </div>
    );
};

export default Home;
